import * as React from 'react';
import coreLogo from '../../../../assets/images/core.png';

const CoreLogo = () => (
    <img src={coreLogo} alt="Core Logo" width="16" height="16" />
);

export default CoreLogo;
